import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { pageTitle } from '../../../util/pageTitles';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

import NoData from '../../../components/NoData/NoData';
import { setChart } from '../../../components/Filter/FilterActions';
import { setPageName } from './../../App/AppActions';
import { getData } from '../CTSPActions';

import Filter from '../../../components/Filter/Filter';
import { DatePicker, Options } from '../../../components/Filter/components';

import CTSPChart from '../components/CTSPChart';
import DetailedOverview from '../components/DetailedOverview';
import DetailsAccordion from '../../../components/DetailsAccordion/DetailsAccordion';
import PercentilesTrendChart from '../components/PercentilesTrendChart';

import { 
  trackTeamDashboardView, 
  trackChartPointDetailsView,
  trackHowToOpened 
} from '../../../util/mixpanel';

import './../CTSP.scss';

class CTSP extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedPoint: {}
    };

    this.handlePointClick = this.handlePointClick.bind(this);

    props.dispatch(setPageName('Cycle time scatter plot'));
  }

  componentDidMount() {
    if (this.props.dashboard && this.props.dashboard._id && this.props.dataIsLoading === false) {
      this.props.setChart('ctsp');

      trackTeamDashboardView('ctsp');
    }
  }

  componentDidUpdate(prevProps) {
    if (
      (prevProps.dataHash != this.props.dataHash ||
        prevProps.hash != this.props.hash ||
        prevProps.enabledColors != this.props.enabledColors ||
        prevProps.selectedDate != this.props.selectedDate) &&
      this.props.dataIsLoading === false
    ) {
      this.handleChange();
    }
  }

  handleChange(force) {
    if (force || !this.props.dataIsLoading) {
      this.setState({
        selectedPoint: {}
      });
      this.props.getData();
    }
  }

  handlePointClick(point) {
    this.setState({
      selectedPoint: point
    });

    trackChartPointDetailsView('ctsp', true);
  }

  trackHowToCTSPOpen() {
    trackHowToOpened('ctsp');
  }

  render() {
    const tooltip = (
      <div className="more_info_tooltip">
        <div className="more_info-inner">
          <p>Use the chart to:</p>
          <ul>
            <li>Analyze your cycle time trends</li>
            <li>Identify the outliers in your process</li>
            <li>Forecast the delivery time of a single work item</li>
          </ul>
          <a
            href={`https://getnave.com/cycle-time-scatterplot`}
            target="_blank"
            onClick={this.trackHowToCFDOpen}
            onAuxClick={this.trackHowToCFDOpen}
            className='btn btn-secondary'
          >
            Learn more
          </a>
        </div>
      </div>
    );

    const totalItems = !this.props.data ? 0 : _.reduce(this.props.data.series, (p, c) => {
      return p + (c.data && c.data.length || 0);
    }, 0);

    return (
      <div className="content-wrap">
        <Helmet>
          <title>{pageTitle(`Cycle Time Scatterplot${this.props.dashboard ? ' | ' + this.props.dashboard.name : ''}`)}</title>
        </Helmet>
        <Filter
          totalItems={totalItems}
          showMetrics
          enablePercentiles
          enableTrendline
          enableSelectedDate
          enableMarkBlocked
          timeunit
          dateformat
        />
        <div className="chart_box_view">
          <div className="dashboard_head">
            <div className="flex-layout">
              <h1>
                Cycle Time Scatterplot
              </h1>
              <div className="more_info_content">
                <span className="more_info"></span>
                {tooltip}
              </div>
            </div>
            <div className="button_tools">
              <Options showMetrics showLineChart options={{ lineChartTooltip: 'Percentiles chart' }} />
              <DatePicker />
            </div>
          </div>
          <div>
            <div className="dashboard_details">
              {this.props.metrics && this.props.data.series && !!this.props.data.series.length && (
                <DetailedOverview id="details" data={this.props.data.series} />
              )}
              {this.props.lineChart && <PercentilesTrendChart data={this.props.percentileTrends} widget="ptc" />}
              <DetailsAccordion
                id="details-accordion"
                data={this.state.selectedPoint}
                chart="ctsp"
                blockedTime={this.props.blockedTime}
                blockers={this.props.blockers}
                dateLabel={`${_.upperFirst(this.props.selectedDate)} date`}
              />
            </div>
            <div className="diagram_details">
              <CTSPChart id="CTSP" data={this.props.data} onPointClick={this.handlePointClick} />
              <NoData show={this.props.data.series && !this.props.data.series.length} loading={this.props.isLoading} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setChart: name => dispatch(setChart(name)),
    getData: () => dispatch(getData())
  };
};

const mapStateToProps = state => {
  return {
    enabledColors: state.filters.enabledColors,
    lineChart: state.filters.ctsp.lineChart,
    blockedTime: state.filters.ctsp.blockedTime,
    blockers: state.filters.ctsp.blockers,
    hash: state.filters.ctsp.hash,
    timeUnit: state.filters.ctsp.timeUnit,
    selectedDate: state.filters.ctsp.selectedDate,
    metrics: state.filters.ctsp.metrics,
    data: state.ctsp.data,
    percentileTrends: state.ctsp.percentileTrends,
    isLoading: state.ctsp.isLoading,
    dashboard: state.dashboards.selected,
    dataIsLoading: state.app.isLoading,
    dataHash: state.app.dataHash,
    app: state.app.app
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CTSP);
